'use client';

import cn from 'classnames';
import { useState } from 'react';

import { useGetAiPlayerItemQuery } from '@shared/api';
import type { Locale } from '@shared/libs';
import { getDate } from '@shared/libs';
import { ButtonExpand, ButtonExpandType, unbounded } from '@shared/ui';

import type { TVideoItem } from '../../model';
import styles from './description.module.css';

type TProps = {
  locale: Locale;
  activeItem: TVideoItem;
  // details: {
  //   summary: string; // саммари
  //   // key: string; // ключ - основной аккорд
  //   tepm: string; // темп
  //   lastUpdate: string; // Последняя модификация
  // };
};

export const Description = ({ locale, activeItem }: TProps) => {
  const [open, setOpen] = useState(false);
  const { data } = useGetAiPlayerItemQuery({ id: activeItem.id });
  if (!data?.data || data?.status === 'recognize' || data?.status === 'error') {
    return null;
  }

  const {
    updated_at,
    details: { summary, temp },
  } = data.data;

  return (
    <div className={styles.card}>
      <div
        className={cn(styles.content, {
          [styles.contentClose]: !open,
        })}
      >
        <p className={cn(styles.title, unbounded.className)}>
          {locale.AI_PLAYER_DETAIL || 'AI_PLAYER_DETAIL'}
        </p>

        <div className={styles.values}>
          <span className={styles.label}>
            {locale.AI_PLAYER_DETAIL_SUMMARY || 'AI_PLAYER_DETAIL_SUMMARY'}:
          </span>
          <span className={styles.value}>{summary}</span>
        </div>

        {/* <div className={styles.values}>
          <span className={styles.label}>
            {locale.AI_PLAYER_DETAIL_KEY || 'AI_PLAYER_DETAIL_KEY'}:
          </span>
          <span className={styles.value}>{key}</span>
        </div> */}

        <div className={styles.values}>
          <span className={styles.label}>
            {locale.AI_PLAYER_DETAIL_TEMP || 'AI_PLAYER_DETAIL_TEMP'}:
          </span>
          <span className={styles.value}>{temp && Math.round(Number(temp))}</span>
        </div>

        <div className={styles.values}>
          <span className={styles.label}>
            {locale.AI_PLAYER_DETAIL_LAST_UPD || 'AI_PLAYER_DETAIL_LAST_UPD'}:
          </span>
          <span className={styles.value}>
            {' '}
            {getDate(updated_at, locale.ORDER_DATE_FORMAT || 'dd.MM.yyyy')}
          </span>
        </div>
      </div>

      <ButtonExpand
        type={open ? ButtonExpandType.CLOSE : ButtonExpandType.OPEN}
        className={open ? undefined : styles.iconClose}
        onClick={() => setOpen((val) => !val)}
      />
    </div>
  );
};
